import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  icon?: ReactNode;
}

export function EmptyState({ title, body, action, icon }: EmptyStateProps) {
  return (
    <div
      style={{
        padding: '40px 24px',
        textAlign: 'center',
        background: 'var(--apm-bg-2)',
        border: '1px dashed var(--apm-line-2)',
        borderRadius: 'var(--apm-radius-lg)',
      }}
    >
      {icon && (
        <div style={{ fontSize: 28, marginBottom: 8, color: 'var(--apm-muted)' }}>
          {icon}
        </div>
      )}
      <div
        style={{
          fontFamily: 'var(--apm-font-display)',
          fontSize: 'var(--apm-text-lg)',
          marginBottom: 4,
        }}
      >
        {title}
      </div>
      {body && (
        <div
          style={{
            color: 'var(--apm-muted)',
            fontSize: 13,
            marginBottom: 16,
            maxWidth: 440,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          {body}
        </div>
      )}
      {action}
    </div>
  );
}
